import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import './Navigation.css';

const Navigation = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'features', label: 'Features' },
    { id: 'architecture', label: 'Architecture' },
    { id: 'tokenomics', label: 'Tokenomics' },
    { id: 'developer', label: 'Developers' },
    { id: 'roadmap', label: 'Roadmap' },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <motion.nav
      className={`tron-navigation ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      data-testid="main-navigation"
    >
      <div className="nav-glow-line"></div>
      <div className="nav-container">
        <div className="nav-logo" onClick={() => scrollToSection('hero')}>
          <img 
            src="https://customer-assets.emergentagent.com/job_592594db-80a8-424b-aef8-5e7847c76b85/artifacts/4f9emqc5_Nomoex%20Logo%20White.svg"
            alt="Nomoex"
            className="nav-logo-svg"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="nav-links desktop-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
              data-testid={`nav-link-${item.id}`}
            >
              <span className="link-text">{item.label}</span>
              <span className="link-glow"></span>
            </button>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="nav-actions desktop-nav">
          <a
            href="https://customer-assets.emergentagent.com/job_592594db-80a8-424b-aef8-5e7847c76b85/artifacts/mcocvfv3_Nomoex%20Chain%20Whitepaper%20V2%20%281%29.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-btn secondary"
            data-testid="nav-whitepaper-btn"
          >
            WHITEPAPER
          </a>
          <a
            href="https://www.mexc.com/exchange/NOMOX_USDT"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-btn primary glow-button"
            data-testid="nav-buy-btn"
          >
            <span>BUY NOMOX</span>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          data-testid="mobile-menu-toggle"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <motion.div
          className="mobile-menu tron-border"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          data-testid="mobile-menu"
        >
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`mobile-nav-link ${activeSection === item.id ? 'active' : ''}`}
              data-testid={`mobile-nav-link-${item.id}`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://customer-assets.emergentagent.com/job_592594db-80a8-424b-aef8-5e7847c76b85/artifacts/mcocvfv3_Nomoex%20Chain%20Whitepaper%20V2%20%281%29.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-btn secondary mobile-cta"
            data-testid="mobile-whitepaper-btn"
          >
            WHITEPAPER
          </a>
          <a
            href="https://www.mexc.com/exchange/NOMOX_USDT"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-btn primary glow-button mobile-cta"
            data-testid="mobile-buy-btn"
          >
            <span>BUY NOMOX</span>
          </a>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navigation;
